/**
 * Shared EVIMO charger-command catalogs (HTTP DTO, NATS contract, web UI).
 * Keep this file free of Nest / class-validator so consumers can import safely.
 */

export const OCPP_CHARGER_COMMAND_ACTIONS = [
  'Reset',
  'ClearCache',
  'GetLocalListVersion',
  'GetConfiguration',
  'TriggerMessage',
  'ChangeConfiguration',
  'GetDiagnostics',
] as const;

export const OCPP_RESET_TYPES = ['Soft', 'Hard'] as const;

/** Curated OCPP 1.6 configuration keys exposed for GetConfiguration. */
export const OCPP_GET_CONFIGURATION_KEYS = [
  'HeartbeatInterval',
  'ConnectionTimeOut',
  'MeterValueSampleInterval',
  'ClockAlignedDataInterval',
  'NumberOfConnectors',
  'GetConfigurationMaxKeys',
] as const;

/** Curated OCPP 1.6 MessageTrigger values for TriggerMessage. */
export const OCPP_TRIGGER_MESSAGES = [
  'StatusNotification',
  'Heartbeat',
  'MeterValues',
  'BootNotification',
  'FirmwareStatusNotification',
  'DiagnosticsStatusNotification',
] as const;

/** User-facing ChangeConfiguration is limited to HeartbeatInterval in this phase. */
export const OCPP_CHANGE_CONFIGURATION_KEYS = ['HeartbeatInterval'] as const;

export type OcppChargerCommandAction =
  (typeof OCPP_CHARGER_COMMAND_ACTIONS)[number];

export type OcppResetType = (typeof OCPP_RESET_TYPES)[number];

export type OcppGetConfigurationKey =
  (typeof OCPP_GET_CONFIGURATION_KEYS)[number];

export type OcppTriggerMessage = (typeof OCPP_TRIGGER_MESSAGES)[number];

export type OcppChangeConfigurationKey =
  (typeof OCPP_CHANGE_CONFIGURATION_KEYS)[number];
